import { Components } from "@mui/material";

export const MuiDialogTitle: Components["MuiDialogTitle"] = {
  styleOverrides: {
    root: {
      paddingTop: 50,
    },
  },
};
